/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Packing_List_Extraction_Not_AllowedInputs */

const en_error_packing_list_extraction_not_allowed = /** @type {(inputs: Error_Packing_List_Extraction_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The reading of the packing list cannot do this now: a reading is out or waits for its review, or the packing list was already typed.`)
};

/**
* | output |
* | --- |
* | "The reading of the packing list cannot do this now: a reading is out or waits for its review, or the packing list was already typed." |
*
* @param {Error_Packing_List_Extraction_Not_AllowedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_packing_list_extraction_not_allowed = /** @type {((inputs?: Error_Packing_List_Extraction_Not_AllowedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Packing_List_Extraction_Not_AllowedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_packing_list_extraction_not_allowed(inputs)
});